import { render, staticRenderFns } from "./off.vue?vue&type=template&id=7dd83392"
import script from "./off.vue?vue&type=script&lang=js"
export * from "./off.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports